module.exports = __webpack_public_path__ + "img/placeholder.7b0cb511.webp";